import gql from 'graphql-tag';
import {resourceFragment} from './fragments';

export const saveResource = gql`
  mutation saveResource($data: ResourceUpdateInput!, $where:  ResourceWhereUniqueInput) {
    saveResource(data: $data, where: $where) ${resourceFragment}
  }
`;
